import { useMemo } from 'react';

import { Navigate } from 'react-router-dom';

import { ForbiddenPage } from '@/components/errors/ForbiddenPage';
import { PageLoading } from '@/components/loading/PageLoading';
import { env } from '@/config/env';
import { useEffectiveMenuPermissions } from '@/features/auth/hooks/useEffectiveMenuPermissions';
import { useGetMyMenuTreeQuery } from '@/features/menus/api/menusApi';
import { useAppSelector } from '@/hooks/useAppSelector';

import { getFirstApiOpsLeafPath, getFirstMergedAccessibleOpsPath } from './opsMenuPaths';

/**
 * Redirects `/ops` — có API: mục đầu tiên theo menu BE; không API: fallback thứ tự tĩnh (dev cục bộ).
 */
export function OpsIndexRedirect() {
  const user = useAppSelector((s) => s.auth.user);
  const { data: menuPermissions } = useEffectiveMenuPermissions();
  const skipMenu = !user || !env.API_BASE_URL;
  const {
    data: menuTree,
    isFetching: menuFetching,
    isError: menuError,
  } = useGetMyMenuTreeQuery(undefined, {
    skip: skipMenu,
  });

  const firstPath = useMemo(() => {
    if (skipMenu) {
      return getFirstMergedAccessibleOpsPath(user, menuPermissions, undefined);
    }
    return getFirstApiOpsLeafPath(menuError ? undefined : menuTree);
  }, [skipMenu, user, menuPermissions, menuError, menuTree]);

  const menuPending = Boolean(env.API_BASE_URL && user && menuFetching);

  if (!user) {
    return <ForbiddenPage />;
  }

  if (!skipMenu && menuPending && !firstPath) {
    return (
      <div style={{ padding: 24 }}>
        <PageLoading />
      </div>
    );
  }

  if (!firstPath) {
    return <ForbiddenPage />;
  }

  return <Navigate to={firstPath} replace />;
}
